import { Helmet } from 'react-helmet';
import MainLayout from "src/layouts";
import MainContainer from "src/components/common/MainContainer";
import SanctionDetail from "src/features/SanctionDetail";

const SanctionDetailPage = () => {
  return (
    <MainLayout>
      <Helmet title="Sanction Detail" />
      <MainContainer sx={{ mt: 2 }}>
        <SanctionDetail />
      </MainContainer>
    </MainLayout>
  );
};

export default SanctionDetailPage;
